import { Pipe, PipeTransform } from "@angular/core";

const schema = {
  "in progress": "orange",
  hold: "powder-pink",
  cdl_in_progress: "red",
  cdl_on_hold: "red",
  cdl_approved: "red",
  "client payment": "cyan",
  "in payment plan": "blue",
  "broken arrangement": "pink",
  one_off_payment: "green",
  legal: "yellow",
  "awaiting client": "red",
  "in dispute": "red",
  cancelled: "gray",
  completed: "green",
  "in review": "red",
  settled: "dark-green",
  admin_review: "dark-cyan",
  "part IX": "part-ix-blue",
};

@Pipe({
  name: "statusColor",
})
export class StatusColorPipe implements PipeTransform {
  transform(value: string): string {
    return schema[value] || "";
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/status-color.pipe.ts